import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "insight-card" }
const _hoisted_2 = { class: "insight-head" }
const _hoisted_3 = {
  key: 0,
  class: "insight-description"
}
const _hoisted_4 = {
  key: 0,
  class: "insight-body"
}
const _hoisted_5 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.description), 1))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
    ]),
    (!_ctx.isEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.emptyText), 1))
  ]))
}